module.exports = __webpack_public_path__ + "img/vertical_4_1_8004.09c57769.png";